/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import PhotoSwipe from "photoswipe/dist/photoswipe";
import PhotoSwipeUi from "photoswipe/dist/photoswipe-ui-default.min";
import Img from "gatsby-image";
import styled from "styled-components";

const Item = styled.div`
  cursor: pointer;
  opacity: 0.95;
  transition: 0.3s ease-in opacity;
`;


export class Gallery extends React.Component {
  initModal(index = 0) {
    let element = document.querySelectorAll(".pswp")[0];

    let items = [];

    this.props.gallery.map(({image}, key) => items.push({
      key: key,
      src: image.full.fluid.src,
      w: image.full.fluid.maxWidth,
      h: image.full.fluid.maxHeight,
    }))

    let options = {
      index: index,
      spacing: 0.8,
      allowPanToNext: true,
      pinchToClose: true,
    };

    let gallery = new PhotoSwipe(element, PhotoSwipeUi, items, options);
    gallery.init();
  }

  openModal(index = 0) {
    this.initModal(index);
  }

  render() {
    let { gallery } = this.props;
    return (
      <>
        {gallery &&
          gallery.map(({ image, description }, key) => {
            return (
              <div key={key}>
                <Item onClick={() => this.openModal(key)}>
                  <Img fluid={image.responsive.fluid} />
                </Item>

                <p>{description}</p>
              </div>
            )
          })}

        <div className="pswp" tabIndex="-1" role="dialog" aria-hidden="true">

          <div className="pswp__bg" />

          <div className="pswp__scroll-wrap">

            <div className="pswp__container">
              <div className="pswp__item" />
              <div className="pswp__item" />
              <div className="pswp__item" />
            </div>

            <div className="pswp__ui pswp__ui--hidden">
              <div className="pswp__top-bar">
                <div className="pswp__counter" />

                <button className="pswp__button pswp__button--close" title="Close (Esc)" />

                <button className="pswp__button pswp__button--share" title="Share" />

                <button className="pswp__button pswp__button--fs" title="Toggle fullscreen" />

                <button className="pswp__button pswp__button--zoom" title="Zoom in/out" />

                <div className="pswp__preloader">
                  <div className="pswp__preloader__icn">
                    <div className="pswp__preloader__cut">
                      <div className="pswp__preloader__donut" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div className="pswp__share-tooltip" />
              </div>

              <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
              </button>

              <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
              </button>

              <div className="pswp__caption">
                <div className="pswp__caption__center" />
              </div>

            </div>

          </div>

        </div>
      </>
    );
  }
}

Gallery.propTypes = {
  contentComponent: PropTypes.func
};

export default Gallery;
